import React, { useContext, useEffect, useState } from 'react'
import { Box, FormControl, Input, Select, Flex, Heading, Button, useToast } from '@chakra-ui/react'

import { TokenContext } from '../App'
import { useNavigate } from 'react-router-dom'
import useForm from '../Hooks/useForm'
import { baseUrl } from '../settings'
import { settingForm } from '../Types/Form'
import { UserContext } from '../App'
import Navbar from '../Navbar/Navbar'



const Settings = () => {

    // @ts-ignore
    const {token, setToken} = useContext(TokenContext)
    const navigate = useNavigate()
    const toast = useToast()

    const initialFormData = {
        "image_url": "",
        "bio": "",
        "doj": "",
        "first": "",
        "last": "",
        "dob": null,
        "gender": ""
    }
    // @ts-ignore
    const {user, setUser} = useContext(UserContext)
    const [form, setForm] = useState(initialFormData) as [settingForm, Function]
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if(token === "" || token === null) {
            // alert('You need to be logged in')
            toast({
                position: 'top-right',
                title: 'Authentication Required',
                description: "You need to be logged In to change Settings",
                status: 'error',
                duration: 9000,
                isClosable: true,
            })
            navigate('/login')
            return
        }
        setLoading(true)

        fetch(`${baseUrl}/auth/user/`, {
            method: "GET",
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => {
            setForm({...form, ...data})
            setLoading(false)
        })
    }, [])

        const uploadImage = (files: FileList | null) => {
        if(files !== null) {
            const file = files![0]
            const formData = new FormData()
            formData.append("file", file)
            formData.append("upload_preset", "tweeter")

            const url = "https://api.cloudinary.com/v1_1/blankc/image/upload"

            fetch(url, {
                method: "POST",
                body: formData
            })
            .then(res => res.json())
            .then(data => {
                setForm({...form, "image_url": data.url})
            })
            .catch(err => console.log(JSON.stringify(err)))
        }
    }


    const handleSettingSubmit = (e: any) => {
        e.preventDefault()
        fetch(`${baseUrl}/auth/user/`, {
            method: "PATCH",
            headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(form)
        })
        .then(() => {
            alert('Success in changing data')
            navigate(-1)
        })
        .catch(err => alert(JSON.stringify(err)))
    } 

    function returnSettingsJSX() {
        return (
            <>
            <Box marginLeft={"20vw"} width={"60%"} boxSizing='border-box'>

                    <Heading textAlign={"center"}>{user?.username || "Guest"}'s Settings</Heading>
                    <FormControl maxWidth={"100vw"} boxSizing='border-box'>
                    <Input type={"file"} onChange={(e) => uploadImage(e.target.files)}></Input>

                    <Input type="bio" placeholder="Enter an awesome Bio" 
                    name="bio" value={form.bio} marginY="1rem"
                    onChange={(e) => {setForm({...form, [e.target.name]: e.target.value})}}></Input>

                    <Input placeholder="Enter your first name here" 
                    name="first" value={form.first} marginY="1rem"
                    onChange={(e) => {setForm({...form, [e.target.name]: e.target.value})}}></Input>

                    <Input placeholder="Enter your last name here" marginY="1rem"
                    name="last" value={form.last}
                    onChange={(e) => {setForm({...form, [e.target.name]: e.target.value})}}></Input>

                    <Select name="gender" id="gender" value={form.gender} onChange={(e) =>  {setForm({...form, [e.target.name]: e.target.value})} }>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="N">Prefer Not to say</option>
                    </Select>

                    <Box textAlign="center" marginTop={"1rem"} display={"flex"} justifyContent={"space-evenly"}>
                        <Button width={"10rem"} type='button' onClick={(e) => handleSettingSubmit(e)}>Submit</Button>
                    </Box>
                
                </FormControl>
                </Box>
            </>
        )
    }

    return (
        <>
            <Navbar></Navbar>
            <Flex height={"100vh"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                {loading ? <p>Loading...</p>: returnSettingsJSX()}
            </Flex>
        </>
    )
}

export default Settings
